var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-down_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.056 20.174c11.677 5.282 20.119 9.824 23.865 15.92 0 0 0-.013.014-.028v.029c3.683-6.03 12.002-10.5 23.517-15.665L30.882 44z"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNy4wNTU5MSAyMC4xNzQxQzE4LjczMyAyNS40NTU4IDI3LjE3NSAyOS45OTc3IDMwLjkyMTEgMzYuMDk0N0MzMC45MjExIDM2LjA5NDcgMzAuOTIxMSAzNi4wODA2IDMwLjkzNTMgMzYuMDY2M0wzMC45MzU0IDM2LjA5NDZDMzQuNjE4MSAzMC4wNjQ0IDQyLjkzNzMgMjUuNTk0MiA1NC40NTE3IDIwLjQzMDNMMzAuODgxOSA0NEw3LjA1NTkxIDIwLjE3NDFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";